module.exports = __webpack_public_path__ + "static/offer-video-f9bee15285ad7f6f04f99c10c40b8172.mp4";